// extracted by mini-css-extract-plugin
export default {"btn-primary":"_styles_btn-primary__DfVeY","inputLabelContainer":"_styles_inputLabelContainer__qXvN1","inputLabel":"_styles_inputLabel__kQAIE","error":"_styles_error__l0NZi"};